export default __webpack_public_path__ + "static/media/grey-scroll-top.779de039.svg";